export const addHash = (color: string) =>
  color[0] === '#' ? color : `#${color}`
